import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './TeilnahmebedingungenModal.module.css';

const BULLET_POINTS = [
  '25 € Rabatt auf die erste Buchung über stu.',
  'Der Rabatt gilt nur für Accounts, die mit derselben E-Mail erstellt werden, die für die Anmeldung verwendet wurde.',
  'Wird eine Buchung vom Anbieter abgelehnt oder storniert, bleibt der Rabatt erhalten. Bei eigener Stornierung verfällt er.',
  'Der Rabatt ist 1 Jahr gültig, nicht auszahlbar oder übertragbar.',
  'Die Aktion läuft bis auf Weiteres. Bereits erhaltene Rabatte bleiben gültig.',
];

export function TeilnahmebedingungenModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={styles.overlay}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={styles.sheet}
        role="dialog"
        aria-modal="true"
        aria-labelledby="teilnahmebedingungen-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h2 id="teilnahmebedingungen-modal-title" className={styles.title}>
            Teilnahmebedingungen
          </h2>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Schließen">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 8.5L0 0.990535L0.990535 0L8.5 7.50947L16.0095 0L17 0.990535L9.49054 8.5L17 16.0095L16.0095 17L8.5 9.49054L0.990535 17L0 16.0095L7.50947 8.5Z" fill="#1F1F1F"/>
            </svg>
          </button>
        </div>
        <ul className={styles.list}>
          {BULLET_POINTS.map((text) => (
            <li key={text}>{text}</li>
          ))}
        </ul>
      </div>
    </div>,
    document.body
  );
}
